import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { style: {"font-size":"font-size: 0.14rem"} }

import { reactive, nextTick, ref } from "vue";
import { ElMessage } from "element-plus";
import type { FormInstance, FormRules } from "element-plus";
import { Axios } from "@/assets/js/ls_com_axios.js";

export default /*@__PURE__*/_defineComponent({
  __name: 'bacnk_card_add',
  emits: ["submit"],
  setup(__props, { expose: __expose, emit: __emit }) {

const allCheckbox = ref(false);
const emit = __emit;
const ruleForm = ref({
  realName: "",
  idCard: "",
  bankName: "",
  bankType: "",
  bankBranch: "",
  bankNo: "",
  mobile: "",
});
const khhList = ref([
  '中信银行','中国银行','招商银行','邮政银行','兴业银行','齐商银行','浦发银行','农业银行','交通银行','建设银行','微商银行','华夏银行','农村信用社银行','光大银行','工商银行','东亚银行','华侨银行','中国平安银行','民生银行','其他'
])
const kkindList = ref([
  {
    name: '储蓄卡',
    value: 'DEBITCARD'
  },
  {
    name: '信用卡',
    value: 'CREDITCARD'
  },
  {
    name: '支付宝',
    value: 'ALIPAY'
  },
  {
    name: '微信',
    value: 'WECHAT'
  },
])
// 校验
const rules = reactive<FormRules>({
  realName: [{ required: true, message: "不能为空！", trigger: "change" }],
  idCard: [{ required: true, message: "不能为空！", trigger: "change" }],
  bankName: [{ required: true, message: "不能为空！", trigger: "input" }],
  bankType: [{ required: true, message: "不能为空！", trigger: "input" }],
  bankBranch: [{ required: true, message: "不能为空！", trigger: "change" }],
  bankNo: [{ required: true, message: "不能为空！", trigger: "change" }],
  mobile: [{ required: true, message: "不能为空！", trigger: "change" }],
});
const ruleFormRef = ref<any>();
const submit = () => {
  if (allCheckbox.value) {
    ruleFormRef.value.validate((valid: boolean) => {
      if (valid) {
        Axios("post", "/member/member-bank", ruleForm.value, false, (res) => {
          emit("submit");
          resetForm(ruleFormRef.value);
        });
      } else {
        ElMessage.warning("请填写完整信息");
      }
    });
  } else {
    ElMessage.warning("请勾选同意《绑定银行卡用户协议》");
  }
};
const init = async () => {
  ruleForm.value = {
    realName: "",
    idCard: "",
    bankName: "",
    bankBranch: "",
    bankNo: "",
    mobile: "",
  };
  allCheckbox.value = false;
  await nextTick();
  ruleFormRef.value.resetFields();
};
const resetForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  init();
  formEl.resetFields();
};
const openagreement = (val) =>{
  window.open(`/agreement?name=${val}`,'_bank')
}
__expose({ init });

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form, {
      style: {"width":"100%"},
      ref_key: "ruleFormRef",
      ref: ruleFormRef,
      model: ruleForm.value,
      "label-width": "100px",
      rules: rules,
      class: "demo-ruleForm",
      "status-icon": "",
      "label-position": "right"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "姓名",
          prop: "realName"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: ruleForm.value.realName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ruleForm.value.realName) = $event)),
              placeholder: "请输入姓名"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "身份证号",
          prop: "idCard"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: ruleForm.value.idCard,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ruleForm.value.idCard) = $event)),
              placeholder: "请输入身份证号"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "开户行",
          prop: "bankName"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: ruleForm.value.bankName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ruleForm.value.bankName) = $event)),
              placeholder: "请选择开户行",
              clearable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(khhList.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: item,
                    value: item,
                    key: index
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "卡类型",
          prop: "bankType"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: ruleForm.value.bankType,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ruleForm.value.bankType) = $event)),
              placeholder: "请选择卡类型",
              clearable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kkindList.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: item.name,
                    value: item.value,
                    key: index
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "支行名称",
          prop: "bankBranch"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: ruleForm.value.bankBranch,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((ruleForm.value.bankBranch) = $event)),
              placeholder: "请输入支行名称"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "银行卡号",
          prop: "bankNo"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: ruleForm.value.bankNo,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((ruleForm.value.bankNo) = $event)),
              placeholder: "请输入银行卡号"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "预留手机号",
          prop: "mobile"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: ruleForm.value.mobile,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((ruleForm.value.mobile) = $event)),
              placeholder: "请输入预留手机号"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_checkbox, {
        modelValue: allCheckbox.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((allCheckbox).value = $event)),
        size: "large",
        style: {"margin-right":"0.06rem"}
      }, null, 8, ["modelValue"]),
      _cache[9] || (_cache[9] = _createTextVNode("同意")),
      _createElementVNode("span", {
        style: {"color":"#C01A26"},
        onClick: _cache[8] || (_cache[8] = ($event: any) => (openagreement('bdyhkyhxy')))
      }, "《绑定银行卡用户协议》")
    ]),
    _createElementVNode("div", {
      class: "cardBnt",
      onClick: submit
    }, "确认添加")
  ]))
}
}

})